import axios from 'axios'

import { useAuth } from '../auth/use-auth'

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

apiClient.interceptors.request.use(
  function (config) {
    const token = config.overrideToken || useAuth.getState().getCookieToken()

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

declare module 'axios' {
  interface AuthRequestConfig {
    overrideToken?: string
  }

  export interface AxiosRequestConfig extends AuthRequestConfig {}
}
